import { render, staticRenderFns } from "./truck-list.vue?vue&type=template&id=3801b2ee&scoped=true"
import script from "./truck-list.vue?vue&type=script&lang=js"
export * from "./truck-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3801b2ee",
  null
  
)

export default component.exports